
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import IComptage from "@/types/comptage.interface";
import SummarySection from "@/components/utils/SummarySection.vue";
import comptageService from "@/services/comptage.service";
import i18n from "@/plugins/vue-i18n";
import dataService from "@/services/data.service";
import frontService from "@/services/front.service";

@Component({
    components: {SummarySection}
})
export default class FiltersList extends Vue {

    @Prop() readonly filters;
    @Prop() readonly product: IComptage;
    @Prop() readonly deleteButton: boolean;
    @Prop() readonly dataTypes;

    filteredActivities = [];
    filteredLegal = [];
    filteredGeolocations = [];
    filteredScore = [];
    filteredKeyNumbers = [];
    filteredAdvanced = [];
    filteredDatas = [];
    filteredFiles = [];

    created() {
        this.updateProduct();
    }

    @Watch("product", {deep: true})
    updateProduct() {
        this.setActivities();
        this.setLegal();
        this.setGeolocation();
        this.setScore();
        this.setKeyNumbers();
        this.setAdvanced();
        this.filteredDatas = dataService.recapDisplay(this.dataTypes, this.product.datas);
        this.filteredFiles = this.product.files;

        /*
        const unsortedData = JSON.parse(JSON.stringify(this.product.datas));
        unsortedData.sort((a, b) => a.id - b.id);
        const identityData = unsortedData.filter(d => d.key === 'identity');
        if ((this.product.type === 'entreprise' && identityData.length === 4) || (this.product.type === 'etablissement' && identityData.length === 3)) {
            const finalData = [...[{
                key: 'identity',
                name: i18n.tc('enrichissement.data.datas.identity')
            }], ...unsortedData.filter(d => d.key !== 'identity')];
            this.filteredDatas = finalData;
        } else {
            this.filteredDatas = unsortedData;
        }
        this.filteredFiles = this.product.files;

         */
    }

    setGeolocation() {
        const geolocations = JSON.parse(JSON.stringify(this.product.filters.geolocation));
        geolocations.forEach(geolocation => {
            geolocation['description'] = frontService.geolocationDescription(geolocation);
        });
        this.filteredGeolocations = geolocations;
    }

    itemText(item) {
        if (item.ville_id) {
            return item.ville_id + ' - ' + item.name;
        } else if (item.departement_id) {
            return item.departement_id.toLocaleString('fr-FR', {minimumIntegerDigits: 2}) + ' - ' + item.name;
        } else {
            return item.name;
        }
    }

    setActivities() {
        if (this.filters && this.filters.naf) {
            const parsedActivities: any[] = JSON.parse(JSON.stringify(this.product.filters.activity));
            let subClassActivities = [];
            let finalActivities = [];
            const allNafSections: any[] = JSON.parse(JSON.stringify(this.filters.naf));
            const allNafSubGroups: any[] = [].concat(...allNafSections.map(a => a.children));
            const allNafSubclass: any[] = [].concat(...[].concat(...allNafSections.map(a => a.children)).map(c => c.children));

            allNafSubGroups.forEach(a => {
                const count = parsedActivities.filter(p => p.naf_groupe_id === a.naf_groupe_id).length;
                if (count > 0) {
                    const allCount = allNafSubclass.filter(s => s.naf_groupe_id === a.naf_groupe_id).length;
                    if (allCount === count) {
                        subClassActivities.push(a);
                    } else {
                        subClassActivities = subClassActivities.concat(...parsedActivities.filter(p => a.naf_groupe_id === p.naf_groupe_id));
                    }
                }
            });
            allNafSections.forEach(a => {
                const count = subClassActivities.filter(p => p.naf_section_id === a.naf_section_id).length;
                if (count > 0) {
                    const allCount = allNafSubGroups.filter(s => s.naf_section_id === a.naf_section_id).length;
                    if (allCount === count) {
                        finalActivities.push(a);
                    } else {
                        finalActivities = finalActivities.concat(...subClassActivities.filter(p => a.naf_section_id === p.naf_section_id));
                    }
                }
            });
            finalActivities = finalActivities.concat(...subClassActivities.filter(p => !p.naf_section_id));
            for (const finalActivity of finalActivities) {
                finalActivity.description = finalActivity.code + ' - ' + finalActivity.description;
            }
            this.filteredActivities = finalActivities;
        }
    }

    setLegal() {
        if (this.filters && this.filters.categoriesJuridique) {
            const parsedLegal: any[] = JSON.parse(JSON.stringify(this.product.filters.legal));
            let finalLegal = [];
            const allLegal: any[] = JSON.parse(JSON.stringify(this.filters.categoriesJuridique));
            const allLegalSubGroups: any[] = [].concat(...allLegal.map(a => a.children));

            allLegal.forEach(a => {
                const count = parsedLegal.filter(p => p.categorie_juridique_niveau_1_id === a.categorie_juridique_niveau_1_id).length;
                if (count > 0) {
                    const allCount = allLegalSubGroups.filter(s => s.categorie_juridique_niveau_1_id === a.categorie_juridique_niveau_1_id).length;
                    if (allCount === count) {
                        finalLegal.push(a);
                    } else {
                        finalLegal = finalLegal.concat(...parsedLegal.filter(p => a.categorie_juridique_niveau_1_id === p.categorie_juridique_niveau_1_id));
                    }
                }
            });
            for (const finalLegalElement of finalLegal) {
                finalLegalElement.description = finalLegalElement.code + ' - ' + finalLegalElement.description;
            }
            this.filteredLegal = finalLegal;
        }
    }

    setScore() {
        this.filteredScore = [];
        for (const key in this.product.filters.score) {
            if (this.product.filters.score[key]) {
                this.filteredScore.push({
                    name: comptageService.solvabilityMap()[key],
                    code: key
                });
            }
        }
    }

    setKeyNumbers() {
        this.filteredKeyNumbers = [];
        const keyNumbersMap = comptageService.keyNumbersMap();
        for (const key in keyNumbersMap) {
            const description = comptageService.getKeyNumbersRangeSentence(key, this.product.filters[key].min, this.product.filters[key].max);
            if (description) {
                this.filteredKeyNumbers.push({
                    name: description,
                    code: key
                });
            }
            const descriptionValue = comptageService.getKeyNumbersValueSentence(key, this.product.filters[key].value);
            if (descriptionValue) {
                this.filteredKeyNumbers.push({
                    name: descriptionValue,
                    code: key
                });
            }
        }
    }

    setAdvanced() {
        this.filteredAdvanced = [];
        const advancedMap = comptageService.getAdvancedMap();
        for (const key in advancedMap) {
            if (this.product.filters[key]) {
                this.filteredAdvanced.push({name: advancedMap[key], code: key});
            }
        }
    }

}
